<script lang="ts" setup>
  import type { Nullable } from '~/core/types'

  type Props = {
    icon: string
    width?: number
    height?: number
    desktopWidth?: number
    desktopHeight?: number
    color?: string
  }

  const props = withDefaults(defineProps<Props>(), {
    width: 22,
    height: 22,
  })

  const matchDesktop = ref(true)
  const iconSvg = ref<Nullable<string>>(null)

  const iconRef = useTemplateRef('icon')

  watch(matchDesktop, () => {
    setSize()
  })

  function setSize() {
    const height = matchDesktop.value ? props.desktopHeight ?? props.height : props.height
    const width = matchDesktop.value ? props.desktopWidth ?? props.width : props.width
    const firstChild = iconRef.value?.firstChild as SVGElement
    if (!firstChild) {
      return
    }
    firstChild.setAttribute('height', height.toString())
    firstChild.setAttribute('width', width.toString())
  }

  function updateIcon() {
    if (import.meta.server) {
      return
    }
    const { matchMedia, addEventListener } = window
    matchDesktop.value = matchMedia('(min-width: 1024px)').matches
    addEventListener('resize', () => {
      if (matchMedia('(min-width: 1024px)').matches !== matchDesktop.value) {
        matchDesktop.value = matchMedia('(min-width: 1024px)').matches
      }
    })
    setSize()
  }

  async function setIcon() {
    try {
      const icon = await import(`~/assets/icons/${props.icon}.svg?raw`)
      iconSvg.value = icon.default ?? null
    } catch (e) {
      // TODO : beaucoup d'erreurs de ce type, 6500 erreurs Sentry depuis le 21/07
      // throw Error(`Error with icon ${props.icon} : ${JSON.stringify(e)}`)
    }
  }
  onMounted(() => {
    updateIcon()
    setIcon()
  })

  onUpdated(() => {
    updateIcon()
    setIcon()
  })

  const computedStyle = computed(() => ({
    fill: props.color,
  }))

</script>
<template>
  <span
    v-if="iconSvg"
    ref="icon"
    :style="computedStyle"
    :class="`c-icon ${icon}`"
    v-html="iconSvg"
  />
</template>
<style scoped>
.c-icon {
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  color: inherit;

  svg {
    fill: inherit;
  }
}
</style>
